import GLOBAL from '../static/json/global.json'

const ENVIRONMENTS = [
    // DEV (LOCAL)
    {
        name: 'dev',
        front: 'localhost',
        admin: 'http://api.four-seasons.local/admin_a69c41',
        api: 'http://api.four-seasons.local/admin_a69c41/wp-json/acf/v3'
    },
    // DEV (FLORIAN)
    {
        name: 'dev',
        front: '192.168.1.97',
        admin: 'https://api.four-seasons.imm-g-prod.com/admin_a69c41',
        api: 'https://api.four-seasons.imm-g-prod.com/admin_a69c41/wp-json/acf/v3'
    },
    // DEV (FLORIAN)
    {
        name: 'dev',
        front: 'four-seasons.local',
        admin: 'http://api.four-seasons.local/admin_a69c41',
        api: 'http://api.four-seasons.local/admin_a69c41/wp-json/acf/v3'
    },
    // PREPROD
    {
        name: 'preprod',
        front: 'imm-g-prod.com',
        admin: 'https://api.four-seasons.imm-g-prod.com/admin_a69c41',
        api: 'https://api.four-seasons.imm-g-prod.com/admin_a69c41/wp-json/acf/v3'
    }
]

const currentURL = window.location.href.toLowerCase()
const getEnv = url =>
{
    let env = ENVIRONMENTS[ENVIRONMENTS.length - 1]

    for (let i = 0, l = ENVIRONMENTS.length; i < l; i += 1)
    {
        if (url.indexOf(ENVIRONMENTS[i].front) !== -1)
        {
            env = ENVIRONMENTS[i]

            return env
        }
    }

    return env
}

const env = getEnv(currentURL)

export default
{
    env,

    json:
    {
        global: '/static/json/global.json',
        content: '/static/json/content.json',
        sounds: '/static/json/sounds.json',
        options: `${env.api}/options/theme-general-settings`
    },

    // Please sort the pages alphabetically
    pages:
    {
        default:
        {
            url: '/',
            name: 'default'
        },
        home:
        {
            url: '/:lang/',
            name: 'page-home',
            meta:
            {
                component: 'page-home',
                name: 'home',
                api:
                {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug.home}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        contact:
        {
            url: '/:lang/contact',
            name: 'page-contact',
            meta:
            {
                component: 'page-contact',
                name: 'contact',
                api:
                {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug.contact}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        chef:
        {
            url: '/:lang/chef',
            name: 'page-chef',
            meta:
            {
                component: 'page-chef',
                name: 'chef',
                api:
                {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug.chef}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        restaurant:
        {
            url: '/:lang/restaurants/:slug',
            name: 'page-restaurant',
            meta:
            {
                component: 'page-restaurant',
                name: 'restaurant',
                api:
                {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug.restaurant}`,
                    restaurant: `${env.api}/restaurants?slug=:slug&per_page=100`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        legalNotice:
        {
            url: '/:lang/legal-notice',
            name: 'page-legal-notice',
            meta:
            {
                component: 'page-legal-notice',
                name: 'legal-notice',
                api:
                {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug.legalNotice}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        notFound:
        {
            url: '/:lang/not-found',
            name: 'page-404',
            meta:
            {
                component: 'page-404',
                name: '404',
                api: {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug['404']}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        },
        404:
        {
            url: '*',
            name: 'page-404',
            meta:
            {
                component: 'page-404',
                name: '404',
                api: {
                    page: `${env.api}/pages?slug=${GLOBAL.pagesSlug['404']}`,
                    restaurants: `${env.api}/restaurants?per_page=100`,
                    bookingModal: `${env.api}/pages?slug=booking-modal`,
                    loadingModal: `${env.api}/pages?slug=loading-modal`,
                    menu: `${env.api}/pages?slug=menu`,
                    footer: `${env.api}/pages?slug=footer`
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/config.js